module.exports = "<div class=information-tooltip><p><%= description %></p><%= information %></div>";